// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usersetting .accountsetting_btn {
  border-radius: 12px;
  padding: 10px 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #DEE0E3;
  transition: all 0.3s ease-in-out;
}
.usersetting .accountsetting_btn:hover {
  background-color: #DEE0E3;
  color: #000;
}
.usersetting.container {
  padding: 20px;
  width: 100%;
  max-width: 1920px;
}
.usersetting {
  display: flex;
  gap: 32px;
}
.usersetting_left {
  width: 206px;
}
.usersetting_left ul {
  list-style: none;
  padding: 0px;
}
.usersetting_left ul li {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 7px 9px;
  border-radius: 10px;
  cursor: pointer;
  color: #14151A;
  text-transform: capitalize;
  font-weight: 500;
  font-size: 14px;
}
.usersetting_left ul li a {
  display: flex;
  gap: 8px;
  align-items: center;
}
.usersetting_left ul li:hover, .usersetting_left ul li.active {
  background-color: rgba(10, 15, 41, 0.0392156863);
}
.usersetting_right {
  width: calc(100% - 238px);
}
.usersetting_right_title {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.usersetting_right_title a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.usersetting_right h3 {
  font-size: 20px;
  font-weight: 500;
  color: #14151A;
  margin-bottom: 24px;
}
.usersetting_right ul {
  display: flex;
  flex-direction: column;
  list-style: none;
  gap: 16px;
  max-width: 306px;
}
.usersetting_right ul li {
  display: flex;
  gap: 4px;
  justify-content: space-between;
}
.usersetting_right ul li label {
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
}
.usersetting_right ul li p {
  color: rgba(15, 19, 36, 0.6);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
}
.usersetting .zoho-checkout-org-table-container {
  width: 100%;
  overflow-x: auto;
}
.usersetting .zoho-checkout-org-table-container .custom-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ddd;
}
.usersetting .zoho-checkout-org-table-container .custom-table th,
.usersetting .zoho-checkout-org-table-container .custom-table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}
.usersetting .zoho-checkout-org-table-container .custom-table th {
  background-color: #f4f4f4;
}
.usersetting .zoho-checkout-org-table-container .custom-table tr {
  background-color: #fff;
}
.usersetting .zoho-checkout-org-table-container .custom-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.usersetting .normal_blue_btn {
  background: #3b82f6;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  max-width: 140px;
  min-width: 100px;
  padding: 5px;
  transition: all 0.3s ease-in-out;
  width: 100%;
}
.usersetting a {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/component/subscription/subscription.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;AAAR;AAEQ;EACI,yBAAA;EACA,WAAA;AAAZ;AAII;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AAFR;AAjBA;EAsBI,aAAA;EACA,SAAA;AAFJ;AAII;EACI,YAAA;AAFR;AAIQ;EACI,gBAAA;EACA,YAAA;AAFZ;AAIY;EACI,aAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AAFhB;AAIgB;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAFpB;AAKgB;EAEI,gDAAA;AAJpB;AAWI;EACI,yBAAA;AATR;AAWQ;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AATZ;AAWY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAThB;AAaQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAXZ;AAcQ;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AAZZ;AAcY;EACI,aAAA;EACA,QAAA;EACA,8BAAA;AAZhB;AAcgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAZpB;AAegB;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAbpB;AAmBI;EACI,WAAA;EACA,gBAAA;AAjBR;AAmBQ;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAjBZ;AAmBY;;EAEI,aAAA;EACA,gBAAA;EACA,sBAAA;AAjBhB;AAoBY;EACI,yBAAA;AAlBhB;AAqBY;EACI,sBAAA;AAnBhB;AAqBgB;EACI,yBAAA;AAnBpB;AAyBI;EACI,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAvBR;AAyBI;EACI,qBAAA;AAvBR","sourcesContent":[".usersetting {\n    .accountsetting_btn {\n        border-radius: 12px;\n        padding: 10px 16px;\n        text-align: center;\n        font-size: 14px;\n        font-weight: 500;\n        border: 1px solid #DEE0E3;\n        transition: all 0.3s ease-in-out;\n\n        &:hover {\n            background-color: #DEE0E3;\n            color: #000;\n        }\n    }\n\n    &.container {\n        padding: 20px;\n        width: 100%;\n        max-width: 1920px;\n    }\n\n    display: flex;\n    gap: 32px;\n\n    &_left {\n        width: 206px;\n\n        ul {\n            list-style: none;\n            padding: 0px;\n\n            li {\n                display: flex;\n                gap: 8px;\n                align-items: center;\n                padding: 7px 9px;\n                border-radius: 10px;\n                cursor: pointer;\n                color: #14151A;\n                text-transform: capitalize;\n                font-weight: 500;\n                font-size: 14px;\n\n                a {\n                    display: flex;\n                    gap: 8px;\n                    align-items: center;\n                }\n\n                &:hover,\n                &.active {\n                    background-color: #0A0F290A;\n                }\n            }\n        }\n\n    }\n\n    &_right {\n        width: calc(100% - 238px);\n\n        &_title {\n            display: flex;\n            justify-content: space-between;\n            gap: 10px;\n\n            a {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            font-weight: 500;\n            color: #14151A;\n            margin-bottom: 24px;\n        }\n\n        ul {\n            display: flex;\n            flex-direction: column;\n            list-style: none;\n            gap: 16px;\n            max-width: 306px;\n\n            li {\n                display: flex;\n                gap: 4px;\n                justify-content: space-between;\n\n                label {\n                    font-size: 16px;\n                    font-weight: 500;\n                    line-height: normal;\n                }\n\n                p {\n                    color: #0F132499;\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: normal;\n                    text-transform: capitalize;\n                }\n            }\n        }\n    }\n\n    .zoho-checkout-org-table-container {\n        width: 100%;\n        overflow-x: auto;\n\n        .custom-table {\n            width: 100%;\n            border-collapse: collapse;\n            border-radius: 10px;\n            overflow: hidden;\n            border: 1px solid #ddd;\n\n            th,\n            td {\n                padding: 12px;\n                text-align: left;\n                border: 1px solid #ddd;\n            }\n\n            th {\n                background-color: #f4f4f4;\n            }\n\n            tr {\n                background-color: #fff;\n\n                &:nth-child(even) {\n                    background-color: #f9f9f9;\n                }\n            }\n        }\n    }\n\n    .normal_blue_btn {\n        background: #3b82f6;\n        border: none;\n        border-radius: 6px;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 600;\n        height: 40px;\n        max-width: 140px;\n        min-width: 100px;\n        padding: 5px;\n        transition: all .3s ease-in-out;\n        width: 100%;\n    }\n    a {\n        text-decoration: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
